import type { Op } from 'quill/core';
import { Delta } from 'quill/core';
import { getDefaultAttachmentMentionText } from '../formats/AttachmentMention';

const deltaToText = (content: Delta | Delta['ops']) => {
  const delta = new Delta(content);
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  return delta
    .map((op) => {
      if (typeof op.insert === 'string') {
        return op.insert;
      }
      return getAttachmentMentionText(op) || op.attributes?.content || '';
    })
    .join('');
};

export const getAttachmentMentionText = (op: Op) => {
  if (
    typeof op.insert === 'object' &&
    op.insert['attachment-mention'] &&
    Array.isArray(op.insert['attachment-mention'])
  ) {
    return typeof op.attributes?.['mention-text'] === 'string' &&
      op.attributes?.['mention-text']
      ? op.attributes?.['mention-text']
      : getDefaultAttachmentMentionText(op.insert['attachment-mention']);
  }
  return null;
};

export default deltaToText;
